export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  tags: string[];
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: string;
  imageUrl: string;
  imageAlt: string;
  content: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
  comments: number;
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  count: number;
}

export interface Comment {
  id: string;
  articleSlug: string;
  userName: string;
  userAvatar: string;
  content: string;
  date: string;
  likes: number;
  rating: number;
  platform: string;
}

export const categories: Category[] = [
  { name: '网红塌房', slug: 'wanghong-tafang', description: '网红塌房现场追踪，第一时间曝光博主翻车实录', count: 128 },
  { name: '黑料合集', slug: 'heiliao-heji', description: '博主黑料大盘点，吃瓜网黑料国产精品内容汇总', count: 96 },
  { name: '国产精品', slug: 'guochan-jingpin', description: '吃瓜网黑料国产精品视频与图文合集', count: 84 },
  { name: '爆料视频', slug: 'baoliao-shipin', description: '博主反差视频与一手爆料素材', count: 67 },
  { name: '吃瓜快讯', slug: 'chigua-kuaixun', description: '51吃瓜网黑料网站最新快讯与实时追踪', count: 153 },
  { name: '博主黑料', slug: 'bozhu-heiliao', description: '热门博主黑料深度扒皮与真相揭秘', count: 72 },
];

export const articles: Article[] = [
  {
    id: '1',
    slug: 'dingji-wanghong-bengkui-quanjilu',
    title: '顶流网红直播间崩溃痛哭，背后金主身份遭实锤曝光',
    excerpt: '曾拥有千万粉丝的顶流网红在直播间情绪失控，随后被扒出与某资本大佬的隐秘关系，塌房现场令人唏嘘。本文为你还原完整事件经过与关键证据链。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    tags: ['网红塌房', '直播翻车', '金主曝光', '吃瓜网黑料'],
    author: '吃瓜前线',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20with%20mask%20in%20dark%20style%2C%20minimalist%20design%2C%20flat%20color%2C%20mystery%20theme&width=120&height=120&seq=author-01&orientation=squarish',
    publishDate: '2026-07-06',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20live%20streaming%20studio%20scene%20with%20emotional%20streamer%20silhouette%2C%20dark%20atmosphere%2C%20neon%20ring%20light%2C%20cinematic%20lighting%2C%20editorial%20photography%2C%20moody%20tones%2C%20warm%20coral%20accents%20against%20dark%20background&width=1200&height=720&seq=article-hero-01&orientation=landscape',
    imageAlt: '网红直播间崩溃痛哭现场画面',
    content: `<p>近日，一则关于某顶流网红在直播间崩溃痛哭的视频在网络上疯传，引发全网热议。这场直播事故不仅暴露了该网红的真实状态，更牵连出一系列不为人知的内幕。</p><p>据知情人士透露，该网红背后存在复杂的资本运作关系。在直播中情绪崩溃的导火索，正是因为与背后的金主发生严重分歧。该金主据传涉及多个行业的投资，而在网红经济领域的布局尤为激进。</p><p>吃瓜网黑料团队经过多日调查，收集到了大量关键证据。其中包括多份内部聊天记录、转账凭证以及与相关人士的采访录音。这些材料清晰地勾勒出了一个由资本主导的网红产业生态。</p><p>事件发生后，该网红的多个社交平台账号出现了异常。有粉丝发现其在某短视频平台的作品被大量下架，而其合作品牌的广告也被暂停投放。这一系列动作被认为是金主方面在危机公关中的紧急应对措施。</p><p>更令人震惊的是，多名与该网红有过合作关系的博主也受到了波及。一位不愿透露姓名的业内人士向51吃瓜网黑料网站爆料："这个圈子远比大家想象的复杂，水太深了。"</p><p>目前，该网红本人尚未对此次事件做出正式回应。但其工作室发布了一则简短的声明，称"正在处理个人事务，感谢粉丝关心"。这则模棱两可的声明反而引发了更多的猜测和讨论。</p>`,
    isHot: true,
    isNew: true,
    views: 285000,
    comments: 3421,
  },
  {
    id: '2',
    slug: 'meizhuang-bozhu-jiahuo-shijian',
    title: '美妆博主被扒产品造假，直播间卖的竟是三无产品',
    excerpt: '51吃瓜网黑料独家爆料：某百万粉丝美妆博主带货产品经检测成分严重超标，背后供应链黑幕触目惊心，消费者权益谁来保障？',
    category: '博主黑料',
    categorySlug: 'bozhu-heiliao',
    tags: ['博主黑料', '美妆造假', '三无产品', '吃瓜网黑料国产精品'],
    author: '黑料调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20investigator%20avatar%20in%20dark%20style%2C%20detective%20theme%2C%20minimalist%2C%20flat%20design%2C%20mysterious&width=120&height=120&seq=author-02&orientation=squarish',
    publishDate: '2026-07-05',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cosmetic%20products%20scattered%20on%20a%20table%20with%20magnifying%20glass%2C%20fake%20beauty%20products%20investigation%20scene%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20warm%20amber%20tones%2C%20mystery%20atmosphere&width=1200&height=720&seq=article-hero-02&orientation=landscape',
    imageAlt: '美妆博主造假产品曝光现场',
    content: `<p>吃瓜网黑料调查组经过长达一个月的暗访和调查，发现某知名美妆博主的直播带货产品存在严重质量问题。经第三方检测机构验证，其销售的多款护肤品中汞含量严重超标，部分产品甚至属于"三无"产品。</p><p>这位拥有超过两百万粉丝的美妆博主，凭借"纯天然""零添加"的营销话术，在直播间创造了单场销售额破千万的记录。然而在光鲜的销售数据背后，隐藏的是一条令人触目惊心的造假供应链。</p><p>调查发现，该博主与一家位于某三线城市的无名代工厂有长期合作关系。该工厂的生产环境极其简陋，根本不具备生产合格化妆品的基本条件。而博主在直播中展示的"工厂直供""源头好货"不过是精心策划的营销骗局。</p><p>更令人愤怒的是，当有消费者在评论区质疑产品质量时，该博主的团队不仅没有正面回应，反而通过删评、拉黑等手段压制负面声音。多名受害者反映，使用这些产品后出现了不同程度的皮肤问题。</p><p>51吃瓜网黑料网站将持续跟进此事，为消费者发声。同时也提醒广大网友，在购买护肤品时务必选择正规渠道，切勿轻信网红推荐。</p>`,
    isHot: true,
    isNew: false,
    views: 198000,
    comments: 2856,
  },
  {
    id: '3',
    slug: 'qinglv-bozhu-fenshou-neimu',
    title: '知名情侣博主官宣分手，背后竟是多人运动丑闻',
    excerpt: '表面上恩爱的情侣博主突宣分手，网友深扒后发现涉及圈内多人不雅事件。吃瓜网黑料独家整理事件全貌，信息量巨大。',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    tags: ['网红塌房', '情侣博主', '多人运动', '黑料合集'],
    author: '吃瓜小能手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20reporter%20avatar%2C%20minimalist%20dark%20style%2C%20flat%20design%2C%20mysterious%20silhouette&width=120&height=120&seq=author-03&orientation=squarish',
    publishDate: '2026-07-04',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Broken%20heart%20symbolism%20with%20two%20silhouettes%20separating%2C%20dramatic%20editorial%20photography%2C%20dark%20crimson%20and%20warm%20tones%2C%20cinematic%20atmosphere%2C%20emotional%20mood&width=1200&height=720&seq=article-hero-03&orientation=landscape',
    imageAlt: '情侣博主分手事件配图',
    content: `<p>本周最大的瓜，莫过于某对拥有八百万粉丝的情侣博主官宣分手。然而事情远没有表面上那么简单——随着网友的不断深挖，一个涉及多人的不雅事件逐渐浮出水面。</p><p>这对情侣博主在过去两年里一直是网友心中的"模范情侣"，两人的互动视频总能获得百万点赞。他们的"恋爱日常"系列更是成为了许多年轻人心中的恋爱教科书。然而这一切，都在本周被彻底颠覆。</p><p>据知情人士向吃瓜网黑料独家透露，两人分手的真正原因并非性格不合，而是因为男方在一次聚会中做出了越界行为。更令人震惊的是，这场聚会涉及到了圈内多名知名的博主和网红。</p><p>目前已有超过五位博主被卷入这场风波。虽然当事人均未正面回应，但多位圈内人士的社交媒体动态暗示了这一事件的真实性。有网友整理了完整的时间线和人物关系图，在各大社交平台上疯狂传播。</p><p>这场风波也让人们开始反思：当网红将私生活当作商品来消费时，真实与表演的边界在哪里？或许对观众来说，最重要的不是吃瓜本身，而是从中看清网红产业的真实面貌。</p>`,
    isHot: true,
    isNew: true,
    views: 412000,
    comments: 5638,
  },
  {
    id: '4',
    slug: 'yundong-bozhu-xingjiashui-puguang',
    title: '运动博主被曝收入造假，"年入千万"全靠PS和分期付款',
    excerpt: '又一位"年入千万"博主翻车了！吃瓜网黑料独家揭秘运动博主如何通过PS截图和租借奢侈品打造虚假人设，真相令人大跌眼镜。',
    category: '黑料合集',
    categorySlug: 'heiliao-heji',
    tags: ['黑料合集', '收入造假', '人设崩塌', '51吃瓜网黑料'],
    author: '真相挖掘机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20blogger%20avatar%20in%20dark%20style%2C%20minimalist%2C%20flat%20design%2C%20investigative%20theme&width=120&height=120&seq=author-04&orientation=squarish',
    publishDate: '2026-07-03',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20sports%20car%20with%20fake%20revenue%20screenshots%20concept%2C%20deception%20theme%2C%20editorial%20style%2C%20warm%20lighting%2C%20contrasting%20shadows%2C%20mystery%20mood&width=1200&height=720&seq=article-hero-04&orientation=landscape',
    imageAlt: '运动博主收入造假曝光配图',
    content: `<p>在自媒体时代，"炫富"似乎已经成了一种吸引流量的固定套路。然而当炫富被戳穿时，场面往往比炫富本身更加精彩。吃瓜网黑料近日接到举报，某知名运动博主的"年入千万"人设完全是一场精心策划的骗局。</p><p>这位博主在社交媒体上频繁晒出豪车、名表和豪华旅行照片，并多次在直播中声称自己"年入千万"。其发布的收入截图和银行流水更是让许多年轻人羡慕不已，纷纷购买其推荐的产品和课程。</p><p>然而经51吃瓜网黑料团队调查发现，这些所谓的"收入证明"大多是通过PS软件修改过的。而其展示的豪车实际上是租赁的，名表则是分期付款购买后又退掉的。甚至连其经常晒出的"私人飞机"照片，也被证实是在某航空体验中心拍摄的。</p><p>多家与该博主合作的品牌方在接受采访时表示，他们也是受害者。这些品牌以为自己在与一位有真实影响力的博主合作，实际上却是在为一个虚假的人设买单。</p><p>此事件再次提醒我们：网络世界真假难辨，理性吃瓜、擦亮双眼才是正确姿势。</p>`,
    isHot: false,
    isNew: true,
    views: 156000,
    comments: 2134,
  },
  {
    id: '5',
    slug: 'zhibo-daihuo-shuajia-beimu',
    title: '直播带货刷单产业链大起底，GMV水分高达70%',
    excerpt: '吃瓜网黑料国产精品深度调查：直播带货行业刷单已成公开秘密，某头部主播真实销量不足GMV的三成。完整刷单产业链揭秘。',
    category: '国产精品',
    categorySlug: 'guochan-jingpin',
    tags: ['国产精品', '直播带货', '刷单产业链', '吃瓜网黑料'],
    author: '深度调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20investigator%20avatar%2C%20dark%20style%2C%20minimalist%20flat%20design%2C%20serious%20tone&width=120&height=120&seq=author-05&orientation=squarish',
    publishDate: '2026-07-02',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20multiple%20screens%20showing%20fake%20orders%2C%20cyber%20fraud%20concept%2C%20cinematic%20lighting%2C%20warm%20orange%20accents%20against%20dark%20background%2C%20mysterious%20atmosphere&width=1200&height=720&seq=article-hero-05&orientation=landscape',
    imageAlt: '直播带货刷单产业链调查配图',
    content: `<p>"家人们，321上链接！""已售10万单！"——这些在直播间里常见的口号背后，究竟有多少是真实的销售数据？吃瓜网黑料国产精品频道经过长达三个月的深度调查，为你揭开直播带货刷单产业链的神秘面纱。</p><p>调查团队通过潜入多个刷单群、采访业内人士以及分析大量数据后发现，直播带货行业的GMV水分普遍在50%以上，部分头部主播的真实销量甚至不足GMV的30%。这意味着你看到的销售奇迹，大多数时候只是一场精心设计的"数字游戏"。</p><p>刷单产业链已经形成了一套完整的运作体系：有专门的刷单平台提供技术支持，有专业的"刷手"团队负责执行，甚至还有专门的资金流转通道来处理退款和佣金结算。整个链条分工明确、运作高效。</p><p>一位在刷单行业工作了两年的人士向51吃瓜网黑料透露："我们一天能刷出几百万的GMV，这在业内根本不算什么。一些顶级主播一场直播下来，真实的订单可能只有GMV的20%到30%。"</p><p>更令人担忧的是，这种虚假繁荣正在对整个电商生态造成严重的负面影响。真实的商家被虚假数据误导，消费者被虚假评价蒙骗，平台的算法也被海量的虚假数据所污染。</p>`,
    isHot: false,
    isNew: false,
    views: 223000,
    comments: 4120,
  },
  {
    id: '6',
    slug: 'yinyue-bozhu-yuanchuang-chaoxi',
    title: '音乐博主原创作品被指抄袭，五首歌涉嫌搬运国外冷门曲目',
    excerpt: '号称"原创音乐人"的博主被扒五首热门歌曲涉嫌抄袭国外冷门作品。吃瓜网黑料独家对比分析，相似度高达90%以上。',
    category: '博主黑料',
    categorySlug: 'bozhu-heiliao',
    tags: ['博主黑料', '音乐抄袭', '原创造假', '吃瓜网站'],
    author: '音乐侦探',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20music%20critic%20avatar%2C%20dark%20minimalist%20style%2C%20flat%20design%2C%20professional%20tone&width=120&height=120&seq=author-06&orientation=squarish',
    publishDate: '2026-07-01',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20notes%20on%20fire%20with%20two%20contrasting%20sheet%20music%20overlapping%2C%20plagiarism%20concept%2C%20dramatic%20editorial%20style%2C%20warm%20amber%20and%20dark%20tones&width=1200&height=720&seq=article-hero-06&orientation=landscape',
    imageAlt: '音乐博主抄袭对比分析配图',
    content: `<p>"原创音乐人"这个标签在短视频平台上已经成为了一门流量密码。然而当原创变成抄袭，流量也就变成了反噬的洪水。吃瓜网黑料接到多位音乐爱好者的举报，某拥有三百万粉丝的音乐博主涉嫌大规模抄袭国外冷门作品。</p><p>经过专业音乐人的对比分析，该博主发布的五首"原创"歌曲与国外多位独立音乐人的作品存在高度相似。其中两首歌曲的旋律相似度超过90%，另外三首在和弦走向和编曲风格上也存在明显的"借鉴"痕迹。</p><p>值得注意的是，这些被抄袭的原作者大多是在国外小有名气但在国内鲜为人知的独立音乐人。这种信息差让该博主的抄袭行为在很长一段时间内都没有被发现。直到一位留学归国的音乐专业学生在偶然间听到了原曲，才揭开了这场抄袭风波。</p><p>事件发酵后，该博主先是发布声明否认抄袭，称"只是巧合"，随后在原作者的维权压力下又改口称"受到了这些作品的启发"。这种前后矛盾的说辞引发了更大的争议。目前，多位被侵权的外国音乐人已经通过法律途径寻求维权。</p>`,
    isHot: true,
    isNew: false,
    views: 178000,
    comments: 2890,
  },
];

export const featuredArticles = articles.filter(a => a.isHot).slice(0, 3);

export const comments: Comment[] = [
  {
    id: 'c1',
    articleSlug: 'dingji-wanghong-bengkui-quanjilu',
    userName: '吃瓜不嫌事大',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20minimalist%20dark%20style%2C%20flat%20design%2C%20casual&width=80&height=80&seq=user-avatar-01&orientation=squarish',
    content: '这个瓜太大了我都吃撑了！之前就觉得这个网红不对劲，果然人设什么的全是靠金主撑着的。最心疼那些真心粉她的粉丝。',
    date: '2026-07-06',
    likes: 2834,
    rating: 5,
    platform: '微博',
  },
  {
    id: 'c2',
    articleSlug: 'dingji-wanghong-bengkui-quanjilu',
    userName: '理性吃瓜群众',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20minimalist%20dark%20style%2C%20flat%20design%2C%20neutral&width=80&height=80&seq=user-avatar-02&orientation=squarish',
    content: '说实话现在的网红圈真的太乱了，资本运作、数据造假、人设包装……真正有才华的反而被埋没。希望这次事件能让行业有所改变吧。',
    date: '2026-07-06',
    likes: 1567,
    rating: 4,
    platform: '抖音',
  },
  {
    id: 'c3',
    articleSlug: 'qinglv-bozhu-fenshou-neimu',
    userName: '八卦使我快乐',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20minimalist%20dark%20style%2C%20flat%20design%2C%20playful&width=80&height=80&seq=user-avatar-03&orientation=squarish',
    content: '当时就觉得这对情侣太完美了反而很假，果然！不过这瓜也太刺激了吧，多人运动什么的简直刷新三观。',
    date: '2026-07-05',
    likes: 3421,
    rating: 5,
    platform: '微博',
  },
  {
    id: 'c4',
    articleSlug: 'meizhuang-bozhu-jiahuo-shijian',
    userName: '美妆小达人',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20minimalist%20dark%20style%2C%20flat%20design%2C%20confident&width=80&height=80&seq=user-avatar-04&orientation=squarish',
    content: '曝光得好！我之前买过她家产品结果烂脸了，找客服根本不理人。这种垃圾博主就该封杀！支持维权！',
    date: '2026-07-05',
    likes: 2108,
    rating: 5,
    platform: '小红书',
  },
  {
    id: 'c5',
    articleSlug: 'zhibo-daihuo-shuajia-beimu',
    userName: '电商老兵',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20minimalist%20dark%20style%2C%20flat%20design%2C%20professional&width=80&height=80&seq=user-avatar-05&orientation=squarish',
    content: '这个调查太详细了，业内人都知道刷单是公开的秘密，但是很少有人敢这么系统地曝光。为调查组点赞！',
    date: '2026-07-03',
    likes: 1892,
    rating: 5,
    platform: '知乎',
  },
  {
    id: 'c6',
    articleSlug: 'yundong-bozhu-xingjiashui-puguang',
    userName: '健身狂魔',
    userAvatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20avatar%20minimalist%20dark%20style%2C%20flat%20design%2C%20energetic&width=80&height=80&seq=user-avatar-06&orientation=squarish',
    content: '哈哈哈笑死，之前还在朋友圈吹他多有钱，现在脸都被打肿了吧。果然网络上什么都是可以P的，连人生都能P。',
    date: '2026-07-04',
    likes: 1234,
    rating: 4,
    platform: '抖音',
  },
];

export const stats = {
  totalArticles: 600,
  totalCategories: 6,
  totalViews: 12800000,
  dailyActive: 85000,
  monthlyExposures: 3200000,
  hotTopics: 128,
};

export const milestones = [
  {
    year: '2024',
    title: '吃瓜网正式上线',
    description: '51吃瓜网黑料网站正式成立，致力于为网友提供最新最热的网红爆料资讯。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Website%20launch%20celebration%20concept%2C%20minimalist%20design%2C%20warm%20cream%20background%2C%20editorial%20style%2C%20soft%20lighting&width=600&height=400&seq=milestone-01&orientation=landscape',
  },
  {
    year: '2024',
    title: '首月破10万用户',
    description: '凭借独家爆料和深度内容，上线首月即吸引超过10万注册用户。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Growing%20audience%20concept%20with%20rising%20graph%2C%20warm%20mint%20green%20background%2C%20editorial%20style%2C%20optimistic%20mood&width=600&height=400&seq=milestone-02&orientation=landscape',
  },
  {
    year: '2025',
    title: '千万级曝光达成',
    description: '单月内容曝光量突破千万，成为吃瓜类内容平台的头部玩家。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20success%20milestone%20concept%2C%20warm%20gray%20background%2C%20editorial%20style%2C%20achievement%20theme%2C%20clean%20design&width=600&height=400&seq=milestone-03&orientation=landscape',
  },
  {
    year: '2026',
    title: '全媒体矩阵布局',
    description: '完成全媒体矩阵布局，覆盖微博、抖音、小红书等多个平台，总粉丝突破500万。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Social%20media%20network%20concept%2C%20warm%20tan%20background%2C%20editorial%20style%2C%20connected%20theme%2C%20modern%20design&width=600&height=400&seq=milestone-04&orientation=landscape',
  },
];